<template>
	<app-page>
		<app-heading title="Communication logs">
			<template v-slot:right>
				<app-button
					outlined
					small
					color="secondary"
					icon="fa-sync"
					@click="refresh = true"
				>Refresh</app-button>
			</template>
		</app-heading>
		<app-filter :value="hasFilters" @click="applyFilters()">
			<app-row no-padding>
				<app-cell cols="6" sm="4">
					<input-select
						v-model="filters.src"
						label="Source"
						:items="services"
						clearable
						dense
					></input-select>
				</app-cell>
				<app-cell cols="6" sm="4">
					<input-select
						v-model="filters.destination"
						label="Destination"
						:items="services"
						clearable
						dense
					></input-select>
				</app-cell>
				<app-cell cols="6" sm="4">
					<input-select
							v-model="filters.status"
							label="Status"
							:items="statuses"
							clearable
							dense
						></input-select>
				</app-cell>
			</app-row>
		</app-filter>
		<app-row>
			<app-cell>
				<app-data-table
					:items="logs"
					:total="count"
					:refresh.sync="refresh"
					:headers="headers"
					:sort-by="'ts'"
					:sort-desc="true"
					@update="fetchLogs"
				>
					<template v-slot:status="{ item }">
						<span
							v-if="item.status === 'warning'"
							class="warning--text"
						>Warning</span>
						<span
							v-if="item.status === 'success'"
							class="success--text"
						>Success</span>
						<span
							v-if="item.status === 'error'"
							class="error--text"
						>Error</span>
					</template>
					<template v-slot:actions="{ item }">
						<app-button
							color="secondary"
							table
							@click="onLogDetails(item._id)"
						>
							Details
						</app-button>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>

		<app-dialog
			v-model="log.show"
			max-width="800"
			height="600"
			max-height="600"
			title="Log details"
		>
			<app-dialog-body>
				<app-row>
					<app-cell xs6>
						<div><b>Request</b></div>
						<app-json :data="log.request" open />
					</app-cell>
					<app-cell xs1></app-cell>
					<app-cell xs5>
						<div><b>Details</b></div>
						<app-json :data="log.details" open />
					</app-cell>
				</app-row>
			</app-dialog-body>
			<app-dialog-footer>
				<app-button
					flat="flat"
					@click="log.show = false"
				>Close</app-button>
			</app-dialog-footer>
		</app-dialog>
	</app-page>
</template>

<script>
import filters from '@/mixins/filters'

export default {
	mixins: [filters],
	data() {
		return {
			logs: [],
			log: {
				show: false,
				request: {},
				details: [],
			},
			services: ['hub', 'studeo'],
			count: -1,
			refresh: false,
			statuses: [{
				text: 'Success',
				value: 'success',
			}, {
				text: 'Warning',
				value: 'warning',
			}, {
				text: 'Error',
				value: 'error',
			}],
			headers: [{
				text: 'Timestamp',
				value: 'ts',
				sortable: true,
				format: 'datetime',
			}, {
				text: 'status',
				value: 'status',
				sortable: true,
			}, {
				text: 'Action',
				value: 'action',
				sortable: true,
			}, {
				text: 'Source',
				value: 'src',
				sortable: false,
			}, {
				text: 'Destination',
				value: 'destination',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
			filters: {
				src: '',
				destination: '',
				status: '',
			},
		}
	},
	methods: {
		async fetchLogs(pagination) {
			const request = this.$ravello.request()
				.v(2)
				.to('communicationlogs')
				.fromPagination(pagination)
				.fields([
					'action',
					'src',
					'destination',
					'ts',
					'status',
				])

			if (this.appliedFilters.src) {
				request.param('src', this.appliedFilters.src)
			}
			if (this.appliedFilters.destination) {
				request.param('destination', this.appliedFilters.destination)
			}
			if (this.appliedFilters.status) {
				request.param('status', this.appliedFilters.status)
			}

			try {
				this.logs = await request.get()
				if (this.count === -1) {
					const count = await request.count()
					this.count = count.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},

		async onLogDetails(id) {
			this.$store.dispatch('app/startLoading')
			const request = this.$ravello.request()
				.v(2)
				.to('communicationlogs')
				.to(id)

			try {
				const log = await request.get()
				this.log.request = log.request
				this.log.details = log.details
				this.log.show = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
